export const ItemTypes = {
    EVENT: 'event'
}